import { HttpService, getError } from './http.service';

const ReportService = {
  ADMIN_API_HOST: process.env.VUE_APP_ADMIN_HOST,

  getReportData(reportDates) {
    return HttpService.httpGet(`${this.ADMIN_API_HOST}/api/admin/report/report-data`, reportDates)
  }
};

export default ReportService;
